export function getFirstFocusableInContainer(root) {
    return (root.querySelector('button:not([disabled]),' +
        '[href],' +
        'input:not([disabled]),' +
        'select:not([disabled]),' +
        'textarea:not([disabled]),' +
        '[tabindex]:not([tabindex="-1"])') ?? null);
}
